var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-main"},[_c('header-bar',{attrs:{"tab-index":"5"}}),_c('about-panel'),_c('side-bar'),_c('footer-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }